module.exports = __webpack_public_path__ + "static/img/title.8360dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/title.png
// module id = 9nKw
// module chunks = 1